export enum TicketPermissions {
    Add = "",
    Get = "",
    List = "",
    Update = "",
    Delete = "",
}
